import NewChat from '@/components/modules/chat/NewChat'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/chat/')({
  component: NewChat,
})
